import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { getCallFeedback, getYukbulMessagesMobile } from "../../features/admin5/admin5Slice";
import { useSelector } from "react-redux";
import avatar from "../../images/img/avatar.jpg"
import moment from "moment";
import Btn from "../../components/shared/button/Btn";
import Pagination from "../../components/shared/Pagination";
import InputSelectCity from "../../components/shared/input/new/InputSelectCity";
import InputText from "../../components/shared/input/new/InputText";
import InputNumberNew from "../../components/shared/input/new/InputNumberNew";
import TopMenus from "../../components/shared/TopMenus";
import InputSelect from "../../components/shared/input/new/InputSelect";
import AdminYukBulContainer from "../../components/adminContainers/AdminYukBulContainer";
import AdminFeedbackContainer from "../../components/adminContainers/AdminFeedbackContainer";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      width: calc(100% - 60px);
      margin: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .top-container{
        width: 80%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        color: ${({theme}) => theme.mainTextColor};
        margin-block: 20px;

        .filter-grp{
            display: flex;
            align-items: center;
            gap: 20px;
            
        }

        .right-side{
            display: flex;
            align-items: center;
            gap: 20px;

            .info-text{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }

        }
      }

      .titles{
        width: 80%;
        margin-bottom: 20px;
        .row{
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 10px;
          text-align: center;
          .col{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
          }
        }
      }

      .list{
        width: 80%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        color: ${({theme}) => theme.mainTextColor};
        
      }
     
      }
  }
`;


const menuData = [
  {
    id:0,
    text:"Yük Bul Mobil"
  },
  {
    id:1,
    text:"Yük Bul Geri Bildirim"
  },
]

const feedBackTypeOptions = [
  {
    id: 0,
    text: "Yükü Aldım",
  },
  {
    id: 1,
    text: "Yükü Almadım",
  },
  {
    id: 2,
    text: "Belki",
  }
]

const YukBulMobil = () => {
  const [activeMenuId, setActiveMenuId] = useState(0)

    const dispatch = useDispatch()
    const {allYukbulMessagesMobile, allYukbulMessagesMobileCount, feedBackList, feedBackListCount} = useSelector(state => state.admin5)
    //! yük bul mobil
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;
    const totalPages = Math.ceil(allYukbulMessagesMobileCount / itemsPerPage);
    const [filterCity, setFilterCity] = useState(null)
    const [filterText, setFilterText] = useState(null)
    const [phoneNumber, setPhoneNumber] = useState("")

    //! geri bildirim
    const [currentPageFeedBack, setCurrentPageFeedBack] = useState(1);
    const itemsPerPageFeedBack = 20;
    const totalPagesFeedBack = Math.ceil(feedBackListCount / itemsPerPageFeedBack);
    const [phoneNumberFeedBack, setPhoneNumberFeedBack] = useState("")
    const [feedBackType, setFeedBackType] = useState(null)


    useEffect(() => {
      if(activeMenuId === 0){

        dispatch(getYukbulMessagesMobile({
          filterCity: filterCity?.value,
          filterText: filterText,
          phoneNumber: phoneNumber,
          page: currentPage
        }));
      }else{
        dispatch(getCallFeedback({page: 1, phoneNumber: phoneNumberFeedBack, feedbackType: feedBackType?.id}))
      }
        
      }, [dispatch, filterCity, filterText, currentPage, phoneNumber, activeMenuId, phoneNumberFeedBack, feedBackType]);


  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Yük Bul"} position="sticky" />
      <div className="content">
      <TopMenus menuList={menuData} activeMenuId={activeMenuId} setActiveMenuId={setActiveMenuId} />
      {
        activeMenuId === 0 ? 
        <>
          <div className="top-container">
              <div className="filter-grp">
                  <InputSelectCity data={filterCity?.value} setData={setFilterCity} name={"filterCity"} labelText={"İle Göre Filtrele"} />
                  <InputText data={filterText} setData={(e) => setFilterText(e.target.value)} name={"workCity"} labelText={"Metne Göre Filtrele"} />
                  <InputNumberNew data={phoneNumber} setData={(e) => setPhoneNumber(e.target.value)} name={"phoneNumber"} labelText={"Telefon Numarası"} />
              </div>
          </div>
          <div className="list">
              {
                  allYukbulMessagesMobile.map((item, index) =>  {
                      return (
                          <AdminYukBulContainer key={index} item={item} />
                      )
                  })
              }
          </div>

          {(allYukbulMessagesMobile && allYukbulMessagesMobile?.length > 0) && (
            <Pagination
              totalPages={totalPages}
              handleClick={setCurrentPage}
              currentPage={currentPage}
            />
          )}
        </>
        :
        <>
          <div className="top-container">
            <div className="filter-grp">
              <InputSelect data={feedBackType?.text} setData={setFeedBackType} name={"feedBackType"} labelText={"Bildirim Durumu"} initialOptions={feedBackTypeOptions} />
              <InputNumberNew data={phoneNumberFeedBack} setData={(e) => setPhoneNumberFeedBack(e.target.value)} name={"phoneNumberFeedBack"} labelText={"Telefon Numarası"} />
              <Btn color="#E85446" width={"130px"} handleClick={() => {setPhoneNumberFeedBack(""); setFeedBackType(null)}} >Temizle</Btn>
            </div>
          </div>

          <div className="titles">
            <div className="row">
              <div className="col">Tarih</div>
              <div className="col">Telefon Numarası</div>
              <div className="col">Bildirim</div>
            </div>
          </div>

          <div className="list">
            {
              feedBackList.map((item, index) =>  {
                return (
                    <AdminFeedbackContainer key={index} item={item} />
                )
              })
            }
          </div>

          {(feedBackList && feedBackList?.length > 0) && (
            <Pagination
              totalPages={totalPagesFeedBack}
              handleClick={setCurrentPageFeedBack}
              currentPage={currentPageFeedBack}
            />
          )}
        </>
      }
        
      </div>
    </div>
  </Container>
  )
}

export default YukBulMobil